import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import React from "react";

export function StaffSelection(props) {
  const {
    formDetail,
    staffOptions,
    setFormDetail,
    multiple = true,
    disabled = false,
  } = props;
  const [searchText, setSearchText] = React.useState("");
  const handleShopChange = async (event) => {
    if (_.includes(event.target.value, "ALL")) {
      if (event.target.value.length - 1 === staffOptions.length) {
        setFormDetail((prev) => {
          return {
            ...prev,
            promoter: [],
          };
        });
      } else {
        setFormDetail((prev) => {
          return {
            ...prev,
            promoter: _.map(staffOptions, (o) => o.id),
          };
        });
      }
    } else {
      setFormDetail((prev) => {
        return {
          ...prev,
          promoter: event.target.value,
        };
      });
    }
  };
  function makeItems(data) {
    const groupByArea = _.groupBy(data, "area_name");
    const items = [];
    _.forEach(groupByArea, (values, area) => {
      items.push(
        <ListSubheader style={{ zIndex: 0 }} key={area}>
          <IconButton
            onClick={(event) => {
              let concatValue = [];
              const isExisting = data.find(
                (d) =>
                  d.area_name === area && formDetail.promoter.includes(d.id)
              );
              if (isExisting) {
                const currentValues = data.filter((options) =>
                  formDetail.promoter.includes(options.id)
                );
                concatValue = _.map(
                  _.filter(currentValues, (d) => d.area_name !== area),
                  "id"
                );
              } else {
                const options = _.filter(
                  staffOptions,
                  (s) =>
                    s.area_name === area &&
                    (s?.staff_code
                      ?.toLowerCase()
                      ?.indexOf(searchText.toLowerCase()) > -1 ||
                      s?.alias
                        ?.toLowerCase()
                        ?.indexOf(searchText.toLowerCase()) > -1)
                );
                concatValue = _.concat(
                  formDetail.promoter,
                  _.map(options, "id")
                );
              }
              setFormDetail((prev) => {
                return {
                  ...prev,
                  promoter: concatValue,
                };
              });
            }}
          >
            {area}
          </IconButton>
        </ListSubheader>
      );
      _.forEach(_.sortBy(values, "staff_code"), (value, index) => {
        items.push(
          <MenuItem key={value.id} value={value.id}>
            <Checkbox
              checked={
                formDetail.promoter.find((d) => d === value.id) !== undefined
              }
            />
            {`${value.staff_code} - ${value.alias} `}
          </MenuItem>
        );
      });
    });
    return items;
  }
  return (
    <FormControl sx={{ width: 300 }}>
      <InputLabel id="staff-select-label">員工</InputLabel>

      <Select
        disabled={disabled}
        MenuProps={{ autoFocus: false }}
        labelId="staff-select-label"
        id="staff-select"
        value={formDetail.promoter}
        label="店鋪"
        multiple={multiple}
        fullWidth
        onChange={handleShopChange}
        renderValue={(selected) => {
          return selected.length === staffOptions.length
            ? "所有員工"
            : `已選擇${selected.length}位員工`;
        }}
        onClose={() => setSearchText("")}
      >
        <ListSubheader
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <TextField
            sx={{ width: 600 }}
            style={{
              backgroundColor: "white",
            }}
            autoFocus
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setSearchText("")}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                // Prevents autoselecting item while typing (default Select behaviour)
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>
        {searchText === "" && (
          <MenuItem
            key={"ALL"}
            value={"ALL"}
            style={{
              position: "sticky",
              top: 56,
              backgroundColor: "white",
              zIndex: 1,
            }}
          >
            <Checkbox
              checked={formDetail.promoter.length === staffOptions.length}
            />
            <ListItemText primary={"所有員工"} />
          </MenuItem>
        )}
        {makeItems(
          _.filter(staffOptions, (s) => {
            return (
              s?.staff_code?.toLowerCase()?.indexOf(searchText.toLowerCase()) >
                -1 ||
              s?.alias?.toLowerCase()?.indexOf(searchText.toLowerCase()) > -1
            );
          })
        )}
      </Select>
    </FormControl>
  );
}
